import {NgModule} from '@angular/core';
import {AdConfigPage} from "./page/overview/ad-config/ad-config.page";
import {AdOverviewPage} from "./page/ad-overview-page/ad-overview.page";
import {AdStatisticsComponent} from "./page/ad-overview-page/components/statisticsComponent/ad-statistics.component";
import {AdKpiComponent} from "./page/ad-overview-page/components/kpiComponent/ad-kpi.component";
import {AD_ENTITY_SERVICE_PROVIDERS} from "./ad.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {AD_TEST_PROVIDERS} from "./test/ad-test-definition";


@NgModule({
    declarations: [
        AdConfigPage,
        AdOverviewPage,
        AdStatisticsComponent,
        AdKpiComponent
    ],
    exports: [
        AdConfigPage
    ],
    imports: [
        CoreModule,
        UiModule
    ],
    providers: [
        AD_ENTITY_SERVICE_PROVIDERS,
        AD_TEST_PROVIDERS
    ]
})
export class AdModule implements DynamicModule {

    alias = 'ad';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return AdKpiComponent;
    }

    getStatisticsComponent() {
        return AdStatisticsComponent;
    }
}
